import { Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import { I18N_COMPONENTS } from '../constants';

export function RemovePriceListModal({
  slug,
  isOpen,
  onClose,
  onConfirm,
  loading,
}: {
  slug: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      primaryAction={{
        text: t(`${I18N_COMPONENTS}.remove_price_list_modal.confirm`),
        onClick: onConfirm,
        danger: true,
        loading,
      }}
      secondaryAction={{ text: t('buttons:cancel'), onClick: onClose }}
    >
      <Modal.Header>{t(`${I18N_COMPONENTS}.remove_price_list_modal.title`)}</Modal.Header>
      <Modal.Body>
        <Text variant="secondary" size="md">
          {t(`${I18N_COMPONENTS}.remove_price_list_modal.message`, { slug })}
        </Text>
      </Modal.Body>
    </Modal>
  );
}
